import axios from "axios";
import keycloak from "../Keycloak";

const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.request.use(async (config) => {
    try {
        await keycloak.updateToken(30);
    } catch {
        keycloak.login();
        return Promise.reject(new Error("Session expired"));
    }
    config.headers.Authorization = `Bearer ${keycloak.token}`;
    return config;
});

axiosApiInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                await keycloak.updateToken(-1);
                originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
                // data was already serialised on the first attempt; without this the replay
                // posts a bare string and XHR labels it text/plain.
                if (typeof originalRequest.data === "string") {
                    originalRequest.headers["Content-Type"] = "application/json";
                }
                return axiosApiInstance(originalRequest);
            } catch {
                keycloak.login();
                return Promise.reject(new Error("Session expired"));
            }
        }
        return Promise.reject(error);
    }
);

export default axiosApiInstance;